/*
|--------------------------------------------------------------------------
| Shared select
|--------------------------------------------------------------------------
|
| TanStack Query memoises a query's `select` per observer. When hundreds of
| components observe the same query through the same selector, every fetch
| runs the selector once per component. A shared selector keeps its result
| per data object instead, so each fetch is transformed once and every
| observer gets the same result by reference. The cache is weak, so results
| go when the data does.
*/

export function sharedSelect<TData extends object, TResult>(
  select: (data: TData) => TResult,
): (data: TData) => TResult {
  const cache = new WeakMap<TData, TResult>()

  return (data) => {
    if (cache.has(data)) return cache.get(data) as TResult

    const result = select(data)
    cache.set(data, result)

    return result
  }
}
